import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function AdminSubmissions() {
    const [items, setItems] = useState([]);
    const [selected, setSelected] = useState(null);
    const [notes, setNotes] = useState("");

    const load = async () => {
        const { data } = await api.get("/consignments");
        setItems(data.items);
    };
    useEffect(() => { load(); }, []);

    const setStatus = async (sid, status) => {
        await api.patch(`/consignments/${sid}`, { status, admin_notes: notes });
        await load();
    };

    if (selected) {
        return (
            <div data-testid="admin-submission-detail">
                <button className="link-underline" onClick={() => setSelected(null)}>← Back</button>
                <h2 style={{ fontFamily: "var(--font-serif)", fontStyle: "italic", marginTop: 16 }}>{selected.full_name}</h2>
                <p style={{ color: "var(--cocoa-soft)" }}>{selected.email} · {selected.phone || "no phone"}</p>
                <p style={{ color: "var(--cocoa-soft)" }}>{selected.return_address}</p>
                <p><span className={`status-pill ${selected.status}`}>{selected.status.replace(/_/g," ")}</span></p>
                {selected.items?.map((it, i) => (
                    <div key={i} style={{ padding: 20, background: "var(--parchment-soft)", margin: "16px 0", border: "1px solid var(--sand-line)" }}>
                        <h4 style={{ fontFamily: "var(--font-serif)", margin: 0 }}>{it.designer} — {it.category}</h4>
                        <p style={{ fontFamily: "var(--font-serif)", color: "var(--cocoa-soft)", margin: "8px 0" }}>Size {it.size} · {it.condition} · {it.color || "—"}</p>
                        <p style={{ fontFamily: "var(--font-serif)", margin: 0 }}>Retail £{it.original_price || "—"} · Asking £{it.asking_price || "—"}</p>
                        {it.description && <p style={{ fontFamily: "var(--font-serif)", color: "var(--cocoa-soft)", marginTop: 8 }}>{it.description}</p>}
                        {it.images?.length > 0 && (
                            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))", gap: 8, marginTop: 12 }}>
                                {it.images.map((src, j) => <img key={j} src={src} alt="" style={{ width: "100%", aspectRatio: 1, objectFit: "cover" }} />)}
                            </div>
                        )}
                    </div>
                ))}
                <div className="field" style={{ marginTop: 24 }}>
                    <label className="label">Admin notes</label>
                    <textarea className="input" rows="3" value={notes} onChange={(e) => setNotes(e.target.value)} />
                </div>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    {["under_review","accepted","listed","sold","paid","declined"].map((s) => (
                        <button key={s} className="btn btn-outline" style={{ padding: "10px 16px", fontSize: 10 }} onClick={() => setStatus(selected.id, s)}>Mark {s.replace(/_/g," ")}</button>
                    ))}
                </div>
            </div>
        );
    }

    return (
        <div data-testid="admin-submissions">
            <div style={{ marginBottom: 16, fontFamily: "var(--font-serif)" }}>{items.length} submissions</div>
            <table className="admin-table">
                <thead><tr><th>Date</th><th>Consignor</th><th>Items</th><th>Status</th><th></th></tr></thead>
                <tbody>
                    {items.map((s) => (
                        <tr key={s.id}>
                            <td style={{ fontFamily: "var(--font-sans)", fontSize: 11 }}>{new Date(s.created_at).toLocaleDateString("en-GB")}</td>
                            <td><div>{s.full_name}</div><div style={{ fontSize: 12, color: "var(--cocoa-soft)" }}>{s.email}</div></td>
                            <td>{s.items?.length}</td>
                            <td><span className={`status-pill ${s.status}`}>{s.status.replace(/_/g," ")}</span></td>
                            <td style={{ textAlign: "right" }}><button onClick={() => { setSelected(s); setNotes(s.admin_notes || ""); }} style={{ background: "transparent", border: "none", cursor: "pointer", fontFamily: "var(--font-sans)", fontSize: 10, letterSpacing: "0.24em", textTransform: "uppercase" }}>Open</button></td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
